import { Metadata_NumberCategory$reflection, Metadata_NumberCategory, Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Kindergarten.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Gender extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "gender";
    }
}

export function Gender$reflection() {
    return class_type("Corpora.Kindergarten.MetadataCategories.Gender", void 0, Gender, Metadata_StringCategory$reflection());
}

export function Gender_$ctor_Z721C83C5(aName) {
    return new Gender(aName);
}

export class Ym extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "ym";
    }
}

export function Ym$reflection() {
    return class_type("Corpora.Kindergarten.MetadataCategories.Ym", void 0, Ym, Metadata_NumberCategory$reflection());
}

export function Ym_$ctor_Z721C83C5(aName) {
    return new Ym(aName);
}

export class Geo extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "geo";
    }
}

export function Geo$reflection() {
    return class_type("Corpora.Kindergarten.MetadataCategories.Geo", void 0, Geo, Metadata_StringCategory$reflection());
}

export function Geo_$ctor_Z721C83C5(aName) {
    return new Geo(aName);
}

export class Lng extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "lng";
    }
}

export function Lng$reflection() {
    return class_type("Corpora.Kindergarten.MetadataCategories.Lng", void 0, Lng, Metadata_StringCategory$reflection());
}

export function Lng_$ctor_Z721C83C5(aName) {
    return new Lng(aName);
}

export class Bhg extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "bhg";
    }
}

export function Bhg$reflection() {
    return class_type("Corpora.Kindergarten.MetadataCategories.Bhg", void 0, Bhg, Metadata_StringCategory$reflection());
}

export function Bhg_$ctor_Z721C83C5(aName) {
    return new Bhg(aName);
}

export class Rec extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "rec";
    }
}

export function Rec$reflection() {
    return class_type("Corpora.Kindergarten.MetadataCategories.Rec", void 0, Rec, Metadata_NumberCategory$reflection());
}

export function Rec_$ctor_Z721C83C5(aName) {
    return new Rec(aName);
}

